import type { ScheduledMeetingsProviderOptions } from '../types';

const MS_IN_SECOND = 1000;
const MS_IN_MINUTE = 60 * MS_IN_SECOND;
const STALE_TIME_MINUTES = 5;
const CACHE_TIME_MINUTES = 10;

/**
 * Default configuration for ScheduledMeetingsContext
 */
export const DEFAULT_CONFIG: Required<ScheduledMeetingsProviderOptions> = {
  // Don't auto-fetch on mount - use lazy loading
  autoFetch: false,

  // Enable background fetch after initial render
  backgroundFetch: true,

  // Wait 2 seconds before background fetch (let page render first)
  backgroundFetchDelay: 2000,

  // Fetch up to 200 meetings with full details by default
  initialQuery: {
    limit: 200,
    detailed: true,
  },

  // Don't auto-refetch (manual refresh only)
  refetchInterval: 0,

  // Data is fresh for 5 minutes
  staleTime: STALE_TIME_MINUTES * MS_IN_MINUTE,

  // Keep in cache for 10 minutes
  cacheTime: CACHE_TIME_MINUTES * MS_IN_MINUTE,
};
